export const invitationExpiredStringList = [
	"No Limit",
	"30 minutes",
	"1 hour",
	"8 hours",
	"24 hours",
	"7 days",
];
